import React from 'react';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/core/styles";
import { colors } from "@material-ui/core"
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
// import InfoOutlinedIcon from '@material-ui/icons/Info';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(theme => ({
  value: {
    fontSize: 14,
    fontWeight: 600,
    color: colors.grey[900],
  },
  formValue: {
    fontSize: 20,
    fontWeight: 600,
    // flex: 1,
    color: colors.grey[900],
    border: 0,
    resize: 'none',
    overflow: 'hidden',
    padding: '-70px',
    backgroundColor: "#F4F6F8",
    maxWidth: '100%'
  },
  MuiTypographyH6: {
    // color: '#263238',
    fontSize: '18px',
    fontFamily: "Roboto",
    fontWeight: 800,
    lineHeight: "20px",
    letterSpacing: "-0.05px",
    color: colors.grey[900],
    backgroundColor: colors.lightBlue[300] 
},
buttonColor:{
  backgroundColor: "#f15a24",
  color: "#F4F6F8"
}
}));

export const Confirm = ({otherNames, formIdValue, fields, onhandleSubmit, handleClosePreview, handleToggleSnack}) => {
  const [open, setOpen] = React.useState(false);
  const classes = useStyles();
  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <div>
      <Button
        autoFocus
        // color="inherit"
        variant="contained"
        size="large"
        className={classes.buttonColor}
        //color="primary"
        // disabled={isSubmitting || !isValid && dirty}
        // type="submit"
        onClick={handleOpen}
      >
        Submit
            </Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="customized-dialog-title" className={classes.MuiTypographyH6}>{"Confirm Submission"}</DialogTitle>
        <DialogContent>
          <DialogContentText>
            <span className={classes.value}>Hi {otherNames}, <br/><br/> Are you sure that you have fully reveiwed your information and that you are ready to submit?</span><br/><br/>
            &nbsp;NB&nbsp;: &nbsp;  Please remember to copy and safely keep your Form ID below.<br/><br/>
            {/* <span className={classes.value}>{formIdValue}</span>   */}
            <span className={classes.value}><textarea wrap="off" className={classes.formValue} variant="h1" value={formIdValue}></textarea></span> 
            <br/>
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary"  variant="outlined">
            Cancel
          </Button>
          <Button onClick={()=>{onhandleSubmit(fields); handleClose(); handleClosePreview(); handleToggleSnack()}} type='submit' color="primary"  variant="contained" autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default Confirm;